import { createTheme, StyledEngineProvider, ThemeProvider as MUIThemeProvider } from '@mui/material/styles'
import { observer } from 'mobx-react-lite'
import { ChildrenProps } from 'src/model/React'
import { getThemeOptions } from '../../util/theme.helper'
import { useLocalizationStore } from '../../../localization/store/localization.store'
import { allLocalesData } from '../../../localization/model/Locale'
import { useMemo } from 'react'
import { CssBaseline } from '@mui/material'

export const AppThemeProvider = observer(({ children }: ChildrenProps) => {
  const { locale } = useLocalizationStore()

  const theme = useMemo(() => {
    return createTheme(
      getThemeOptions() as any,
      allLocalesData[locale].muiSystem,
    )
  }, [locale])

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  )
})
